export default function LocationFactory(UrlFactory, Error) {
    const factory = this;

    factory.findLocationBySlug = function (slug, locations) {
        let found = null;
        angular.forEach(locations, function (location) {
            if (UrlFactory.slugify(location.Name) == UrlFactory.slugify(slug)) {
                found = location;
            }
        });
        if (!found) {
            return new Error("no-location", "Lokationen blev ikke fundet");
        }
        return found;
    };

    /**
     * LEGACY
     */
    factory.getById = function (id, locations) {
        let found = null;

        angular.forEach(locations, function (location) {
            if (location.ID == id) {
                found = location;
            }
        });
        if (!found) {
            return new Error("no-location", "Lokationen blev ikke fundet");
        }
        return found;
    };

    return factory;
}
